import React, { createContext, useContext, ReactNode } from 'react';
import { IWorkplaceRoleDTO } from '@common-frontend-submodule/interfaces/workplace-role/iworkplace-role.interface';
import { IWorkplaceRoleCreationDTO } from '@common-frontend-submodule/interfaces/workplace-role/iworkplace-role-creation.interface';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { WorkplaceRoleRoutes } from '@common-frontend-submodule/enums/routes/workplace-role-routes.enum';
import ApiClient from '../../lib/api-client';

interface WorkplaceRoleContextProps {
  getByWorkplaceId: (workplaceId: string) => Promise<IApiResponseGenericDTO<IWorkplaceRoleDTO[]>>;
  create: (model: IWorkplaceRoleCreationDTO) => Promise<IApiResponseGenericDTO<IWorkplaceRoleDTO>>;
  delete: (workplaceRoleId: string) => Promise<IApiResponseGenericDTO<boolean>>;
}

const WorkplaceRoleContext = createContext<WorkplaceRoleContextProps | undefined>(undefined);

const apiClient = ApiClient.getInstance()

export const WorkplaceRoleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const getByWorkplaceId = async (workplaceId: string): Promise<IApiResponseGenericDTO<IWorkplaceRoleDTO[]>> => {
    return await apiClient.getRequest<IWorkplaceRoleDTO[]>(`${WorkplaceRoleRoutes.BasePrefix}/all/${workplaceId}`);
  };

  const create = async (model: IWorkplaceRoleCreationDTO): Promise<IApiResponseGenericDTO<IWorkplaceRoleDTO>> => {
    return await apiClient.postRequest<IWorkplaceRoleCreationDTO, IWorkplaceRoleDTO>(WorkplaceRoleRoutes.BasePrefix, model);
  };

  const deleteRole = async (workplaceRoleId: string): Promise<IApiResponseGenericDTO<boolean>> => {
    return await apiClient.deleteRequest<null, boolean>(`${WorkplaceRoleRoutes.BasePrefix}/${workplaceRoleId}`);
  };

  return (
    <WorkplaceRoleContext.Provider value={{ getByWorkplaceId, create, delete: deleteRole }}>
      {children}
    </WorkplaceRoleContext.Provider>
  );
};

export const useWorkplaceRoleStore = (): WorkplaceRoleContextProps => {
  const context = useContext(WorkplaceRoleContext);
  if (!context) {
    throw new Error('useWorkplaceRoleStore must be used within a WorkplaceRoleProvider');
  }
  return context;
};
